import React from 'lib/react';
import { EVGrid, EVTypography, makeStyles } from 'lib/components';
import { useTranslation } from 'lib/translation';
import {
  ORDER_HISTORY_ROUTE,
  ORDER_PREFERENCES_ROUTE,
} from 'constants/RouteConstants';
import { Link } from 'lib/router';

const useStyles = makeStyles((theme) => ({
  links: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
    padding: '16px 0 24px 0',
    '@media (min-width: 640px)': { paddingTop: '24px' },
  },
  message: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  clickable: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    textDecoration: 'none',
    color: theme.evPalette.ocean[500],
  },
}));

function Links() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <EVGrid className={classes.links}>
      <EVTypography className={classes.message}>
        {t('order_submitted__track_order_msg_1')}
        <Link className={classes.clickable} to={ORDER_HISTORY_ROUTE}>{t('order_submitted__track_order_msg_2')}</Link>
        {t('order_submitted__track_order_msg_3')}
      </EVTypography>
      <EVTypography className={classes.message}>
        {t('order_submitted__order_preferences_msg_1')}
        <Link className={classes.clickable} to={ORDER_PREFERENCES_ROUTE}>{t('order_submitted__order_preferences_msg_2')}</Link>
        {t('order_submitted__order_preferences_msg_3')}
      </EVTypography>
    </EVGrid>
  );
}

export default Links;
